<template>
  <layoutDefault>
    <!-- title -->
    <ContentTitle ref="top" title="특화서비스 통계">
      <template v-slot:subTitle>
        <router-link :to="'/stats/v1'" style="color:#ea002c;">[이전 통계 바로 가기]</router-link>
      </template>
      <template v-slot:description>
        <span style>
          * 2020년 8월 이후 이용 통계만 조회 가능하며, 2020년 7월까지 통계는
          <router-link :to="'/stats/v1'" style="color:#ea002c;">[이전 통계]</router-link>페이지를 이용해 주세요.
        </span>
      </template>
    </ContentTitle>
    <!-- //title -->

    <ul class="section_tab">
      <li v-for="item in linkArr" class="cell" :key="item.to">
        <router-link :to="item.to" active-class="selected" class="item">{{item.name}}</router-link>
      </li>
    </ul>

    <router-view></router-view>
  </layoutDefault>
</template>

<script>
export default {
  name: "analytics",
  data() {
    return {
      linkArr: [
        { name: "전체통계(Daily)", to: "/stats/v2/daily" },
        { name: "전체통계(Monthly)", to: "/stats/v2/monthly" },
        { name: "소식톡톡 통계", to: "/stats/v2/news" },
        { name: "두뇌톡톡/기억검사 통계", to: "/stats/v2/game_use" },
        { name: "두뇌톡톡 콘텐츠 통계", to: "/stats/v2/game_content" },
        { name: "건강백세 통계", to: "/stats/v2/health_use" },
        { name: "건강백세 콘텐츠 통계", to: "/stats/v2/health_content" },
        { name: "대상자별 통계", to: "/stats/v2/user" }
      ]
    };
  }
};
</script>
